module.exports = __webpack_public_path__ + "Flama-SemiboldItalic.woff2?3ee296cdcc5be3d90082b963a75c648d";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-SemiboldItalic.woff2
// module id = 902
// module chunks = 0